import React from "react";
import {MainCP}  from "../../Components/grafico-doble/MainCP"

const ViewGraficoDoble: React.FC = () => <MainCP/>

export default ViewGraficoDoble;